import { Button } from '../../../components/Button/NewButton';
import React from 'react';
import { useCreateOperator } from '../../../contexts/CreateOperatorContext';
import clsx from 'clsx';

export const ResultsFooter = () => {
  const { completed, onBack, onComplete, summary, progress } =
    useCreateOperator();
  const createOperatorFailed = summary[0]?.error !== null;
  const notCompleted =
    completed === false || summary.every((step) => step.completed) === false;

  const renderNextSteps = () => {
    if (notCompleted) return;
    return (
      <div
        className={clsx('transition-opacity duration-500 py-6', {
          ['opacity-0']: notCompleted,
          ['opacity-100']: notCompleted === false,
        })}
      >
        <p className="text-lg">Next Steps:</p>
        <p className={'text-xs opacity-70'}>
          Access to this new operator will need to be added to your role.
          <br />
          Reach out to the development team for assistance.
        </p>
      </div>
    );
  };

  return (
    <div>
      {renderNextSteps()}
      <div
        className={clsx('grid grid-rows-1 gap-2 py-4', {
          ['grid-cols-2']: createOperatorFailed,
        })}
      >
        {createOperatorFailed && progress.completed ? (
          <Button onClick={onBack} fullWidth>
            Review Operator
          </Button>
        ) : null}
        <Button disabled={notCompleted} onClick={onComplete} fullWidth>
          Finished
        </Button>
      </div>
    </div>
  );
};
